<div class="container mt-2" *ngIf="!isBookingHistory && !isPaymentHistory && !IsYogaBooking">
  <div class="d-flex justify-content-between">
    <h1 class="d-flex align-items-start" style="font-family: sans-serif;font-size: 2em;">Online Yoga</h1>
    <div class="d-flex justify-content-end align-items-center mb-2">
      <button class="btn" title="Add New Participant"
        style="font-family: sans-serif;font-size: 1.16em;background-color: #77c5ec;" (click)="AddNew(content);">
        <!-- GetsigninDetails('Addbutton') -->
        <strong>Add New Participant</strong></button> <!---- Add New Participant ------>
    </div>
  </div>
  <div class="container mt-2">
    <div class="chk-block-content mt-2">
      <div class="table-responsive">
        <div class="unseen">
          <table class="table table-striped table-hover  text-left " data-page-size="15" data-filtering="true"
            data-sorting="true">
            <thead>
              <tr style="font-family: sans-serif;font-size: 1.16em;background-color: #77c5ec;">
                <!-- class="bg-white" -->
                <th style="min-width: 30px !important; max-width: 30px !important;">No.</th>
                <th>Participant Name</th>
                <th>DOB</th>
                <th>Age</th>
                <th>Gender</th>
                <th>Address</th>
                <th>Status</th>
                <th class="numeric text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr style="font-family: Calibri;font-size: 1.16em;background-color: #e3ebdc;"
                *ngFor="let item of items | filter : filters | paginate: { itemsPerPage: 10, currentPage: page };  let i = index">
                <td style="min-width: 20px !important; max-width: 20px !important;">
                  {{ 10 * (page - 1) + i + 1}}
                </td>
                <td>{{item.GuestName}}</td>
                <td>{{item.DateOfBirth | date:"dd-MMM-yyyy"}}</td>
                <td>{{item.Age}}</td>
                <td> {{item.Gender}}</td>
                <td> {{item.City}}</td>
                <!-- <td> {{item.BookingStatus == 'Unutilized by the Patient/guest' ? 'Booked' : 'Book your slot'}}</td> -->
                <td
                  [style]="item.YogaBookingStatus == 'Unutilized by the Patient/guest' ?  'background-color: green;color: white;' : 'background-color: #fd7f33;color: white;'">
                  <label style="margin-bottom: 0;">
                    {{item.YogaBookingStatus == 'Unutilized by the Patient/guest' ? 'Booking Done' :
                    item.YogaBookingStatus ==
                    'Booking Pending' ? 'Booking Pending' :'No Booking'}}
                  </label>
                </td>
                <td
                  class="numeric text-center font text-nowrap style=min-width: 30px !important; max-width: 30px !important;">
                  <i class="fa-lg fa fa-calendar-o mr-1" style="color:#6c757d"
                    (click)="GetYogaBookingHistory(item.OnlinePatientRegistrationID);" title="Yoga Booking history"></i>
                  <i class="fa-lg fa fa-calendar-check-o mr-1" style="color:#28a745"
                    *ngIf="item.Activate && (item.YogaBookingStatus !== 'Unutilized by the Patient/guest' && item.YogaBookingStatus !== 'Booking Pending')"
                    (click)="item.YogaBookingStatus !== 'Unutilized by the Patient/guest' ? GetcheckFunction(item.GuestName, item.OnlinePatientRegistrationID) : null"
                    title="New Yoga Package"></i>
                  <i class="fa-lg fa fa-money mr-1 text-warning" title="Payment History"
                    (click)="GetPaymentHistory(item.OnlinePatientRegistrationID);"></i>
                </td>
            </tbody>
          </table>
        </div>
        <pagination-controls (pageChange)="page = $event" [maxSize]="10" [directionLinks]="true" [autoHide]="true"
          [responsive]="true">
        </pagination-controls> <!----- Page No ------>
      </div>
    </div>
  </div>
</div>

<!-- Yoga Booking -->
<div class="container ttm-bgcolor-whiteecolor"
  *ngIf="IsYogaBooking && !IsYogaBookingDate && !IsMakePayment && !isFinalPayment">
  <div class="row mt-3 fontsizeandfamilyCalibri">
    <div class="col-lg">
      <div class="grid-b-space">
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblGuestName">Participant Name</label><!--Guest Name-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestName}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblExpectedcheckin">Date of birth</label> <!--Expected check-in-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestQuetionaridetails[0].DateOfBirth | date:"dd-MMM-yyyy"}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblExpectedcheckout">Age</label><!--Expected check-out-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestQuetionaridetails[0].Age}}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg">
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblNoofdays">Sex</label><!----No. of days---->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestQuetionaridetails[0].Gender}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblAccomodation">Address</label><!--Accomodation-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestQuetionaridetails[0].Address}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblEmail">E-mail</label><!--E-mail-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{UserEmail}}</strong>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let pkg of yogaPackages" class="container border fontsizeandfamilyCalibri">
    <div class="bg-primary text-white p-2 rounded-top">
      {{ pkg.YogaPackageName }}
      <span *ngIf="pkg.disease">({{ pkg.disease }})</span>
    </div>
    <div class="row p-3">
      <div class="col-md-3" *ngFor="let session of pkg.sessions">
        <div class="card h-100 text-center shadow-sm">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-2">
              <div class="col-md-6 text-right fw-bold"><strong>Sessions</strong></div>
              <div class="col-md-6 text-left">{{ session.duration }}</div>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <div class="col-md-6 text-right fw-bold"><strong>Amount(Rs.)</strong></div>
              <div class="col-md-6 text-left">{{ session.amount | number:'1.2-2' }}</div>
            </div>
            <button class="btn btn-primary" *ngIf="disableSundays" (click)="GetYogaBooking(pkg,session)">Book</button>
            <button class="btn btn-primary" *ngIf="!disableSundays">No Class</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row d-flex justify-content-center fontsizeandfamilyCalibri">
    <button class="btn btn-success fa-sm ml-5 mt-1" (click)="LoadGuest()">Participant List</button>
  </div>
</div>

<!-- Yoga Booking Date -->
<div class="container ttm-bgcolor-whiteecolor" *ngIf="IsYogaBookingDate && !IsMakePayment && !isFinalPayment">
  <div class="row mt-3 fontsizeandfamilyCalibri">
    <div class="col-lg">
      <div class="grid-b-space">
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblGuestName">Participant Name</label><!--Guest Name-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestName}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblExpectedcheckin">Date of birth</label> <!--Expected check-in-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestQuetionaridetails[0].DateOfBirth | date:"dd-MMM-yyyy"}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblExpectedcheckout">Age</label><!--Expected check-out-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestQuetionaridetails[0].Age}}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg">
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblNoofdays">Sex</label><!----No. of days---->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestQuetionaridetails[0].Gender}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblAccomodation">Address</label><!--Accomodation-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestQuetionaridetails[0].Address}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblEmail">E-mail</label><!--E-mail-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{UserEmail}}</strong>
        </div>
      </div>
    </div>
  </div>
  <div class="fontsizeandfamilyCalibri">
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>Yoga Package Type </label>
      </div>
      <div class="col-md text-left mt-2">
        <strong>
          {{ selectedPackage['YogaPackageName'] }} ({{ selectedPackage['disease'] }})
        </strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>
          Sessions
        </label>
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>
          {{ selectedsession['duration'] }}
        </strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>Amount (Rs.) </label>
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>
          {{ selectedsession['amount'] }}
        </strong>
      </div>
    </div>
  </div>

  <table class="table-striped text-center">
    <thead>
      <tr style="font-family: sans-serif;font-size: 1.16em;background-color: #77c5ec;">
        <th>Batch Time and Days</th>
        <th>Instructor</th>
        <th *ngFor="let date of upcomingDates; let i = index">
          <div>
            {{ date | date: 'EEE dd MMM yyyy' }}
          </div>
          <div>
            <button class="btn btn-light btn-sm" *ngIf="i != 0" (click)="generateUpcomingDates(7,date)">Next
              Week</button>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let batch of batches" style="font-family: Calibri;font-size: 1.16em;background-color: #e3ebdc;">
        <td>
          {{ batch.time }}<br />
          - {{ batch.days }}
        </td>
        <td>{{ batch.instructor }}</td>
        <td *ngFor="let date of upcomingDates">
          <ng-container *ngIf="!isHoliday(date); else noClass">
            <button class="btn btn-primary btn-sm" (click)="MakePayment(date)">Book</button>
          </ng-container>
          <ng-template #noClass>
            <span>No Class</span>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="row mt-2 d-flex justify-content-end fontsizeandfamilyCalibri">
    <button class="btn btn-success fa-sm ml-5 mt-1" (click)="GetBack()">Back</button>
  </div>
</div>

<!-- Make Payment -->
<div class="container ttm-bgcolor-whiteecolor" *ngIf="IsMakePayment && !isFinalPayment">
  <div class="row mt-3 fontsizeandfamilyCalibri">
    <div class="col-lg">
      <div class="grid-b-space">
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblGuestName">Participant Name</label><!--Guest Name-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestName}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblExpectedcheckin">Date of birth</label> <!--Expected check-in-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestQuetionaridetails[0].DateOfBirth | date:"dd-MMM-yyyy"}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblExpectedcheckout">Age</label><!--Expected check-out-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestQuetionaridetails[0].Age}}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg">
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblNoofdays">Sex</label><!----No. of days---->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestQuetionaridetails[0].Gender}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblAccomodation">Address</label><!--Accomodation-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestQuetionaridetails[0].Address}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblEmail">E-mail</label><!--E-mail-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{UserEmail}}</strong>
        </div>
      </div>
    </div>
  </div>
  <div class="fontsizeandfamilyCalibri">
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>Service </label>
      </div>
      <div class="col-md text-left mt-2">
        <strong>
          Online Yoga Package
        </strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>Yoga Package Type </label>
      </div>
      <div class="col-md text-left mt-2">
        <strong>
          {{ selectedPackage['YogaPackageName'] != '' ? '(' + selectedPackage['disease'] + ')' : '' }}
        </strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>
          Sessions
        </label>
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>
          {{ selectedsession['duration'] }}
        </strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>
          Yoga Batch
        </label>
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>
          {{ selectedPackage['time'] }}
        </strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>
          Yoga Instructor
        </label>
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>
          {{ selectedPackage['instructor'] }}
        </strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>
          Start Date
        </label>
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>
          {{ SelectedYogaBookingDate | date:"EEE dd MMM yyyy" }}
        </strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label>Amount (Rs.) </label>
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>
          {{ selectedsession['amount'] }}
        </strong>
      </div>
    </div>
  </div>

  <div class="row mt-2 d-flex justify-content-end fontsizeandfamilyCalibri">
    <div class="row ml-2">
      <div class="col-md-5 text-left mt-2">
        <strong id="lblPayment">Payment Service Provider</strong> <!--Payment Service Provider-->
      </div>
      <div class="col-md-7 mt-2">
        <input type="" class="form-control mt-1" name="Payment" autocomplete="off" id="Payment"
          [(ngModel)]="PaymentServiceProvider" placeholder="Payment Service Provider" disabled />
      </div>
    </div>
  </div>
  <div class="row mt-2 d-flex justify-content-end fontsizeandfamilyCalibri">
    <button class="btn btn-success fa-sm ml-5 mt-1" (click)="FinalMakePayment()">Make Payment</button>
  </div>

  <div class="row mt-2 d-flex justify-content-end fontsizeandfamilyCalibri">
    <button class="btn btn-success fa-sm ml-5 mt-1" (click)="GetBack()">Back</button>
  </div>
</div>

<!-- Make Final payment screen -->
<div class="container mt-5" *ngIf="isFinalPayment">
  <div class="row fontsizeandfamilyCalibri">
    <div class="col-lg">
      <div class="grid-b-space">
        <div class="row">
          <div class="col-md-5 text-right mt-2">
            <strong id="lblGuestName">Guest Name</strong><!--Guest Name-->
          </div>
          <div class="col-md-5 mt-2 text-left">
            <label>{{GuestName}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5 text-right mt-2">
            <strong id="lblPaymentType">Payment Type</strong><!--Payment Type-->
          </div>
          <div class="col-md-5 mt-2 text-left">
            <label>Online yoga class</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5 text-right mt-2">
            <strong id="lblPaymentType">Product Info.</strong><!--Payment Type-->
          </div>
          <div class="col-md-5 mt-2 text-left">
            <label>Online Yoga Package</label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg">
      <div class="row">
        <div class="col-md-5 text-right mt-2">
          <strong id="lblPaymentDate">Payment Date/Time</strong><!--Payment Date/Time-->
        </div>
        <div class="col-md-5 mt-2 text-left">
          <label>{{Today | date:'dd-MM-yyyy'}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 text-right mt-2">
          <strong id="lblAmount">Amount (Rs.)</strong><!--Amount (Rs.)-->
        </div>
        <div class="col-md-5 mt-2 text-left">
          <label>{{selectedsession['amount']}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 text-right mt-2">
          <strong id="lblPhone">Phone</strong><!--Phone-->
        </div>
        <div class="col-md-5 mt-2 text-left">
          <label>{{ GuestQuetionaridetails[0].MobileNo}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 text-right mt-2">
          <strong id="lblEmail">E-mail</strong><!--E-mail-->
        </div>
        <div class="col-md-5 mt-2 text-left">
          <label>{{UserEmail}}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between mt-2 fontsizeandfamilyCalibri">
    <button class="btn btn-danger fa-sm ml-5 mt-1" (click)="GetBack()">Cancel Payment</button>
    <button id="MakeFinalPayment" class="btn btn-success fa-sm mr-5 mt-1"
      [disabled]="this.itemToEditYogaBooking.ThirdpartyPaymentID != ''" (click)="GetRazorpay()">Make Payment</button>
  </div>
</div>

<!---Booking History-->
<div class="container ttm-bgcolor-whiteecolor" *ngIf="isBookingHistory">
  <div class="row mt-3 fontsizeandfamilyCalibri">
    <div class="col-lg">
      <div class="grid-b-space">
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblGuestName">Participant Name</label><!--Guest Name-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestName}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblExpectedcheckin">Date of birth</label> <!--Expected check-in-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestQuetionaridetails[0].DateOfBirth | date:"dd-MMM-yyyy"}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblExpectedcheckout">Age</label><!--Expected check-out-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{GuestQuetionaridetails[0].Age}}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg">
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblNoofdays">Sex</label><!----No. of days---->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestQuetionaridetails[0].Gender}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblAccomodation">Address</label><!--Accomodation-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestQuetionaridetails[0].Address}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblEmail">E-mail</label><!--E-mail-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{UserEmail}}</strong>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4 justify-content-center">
    <div class="table-responsive">
      <div class="unseen fontsizeandfamilyCalibri">
        <table class="table table-striped table-hover  text-left " data-page-size="15" data-filtering="true"
          data-sorting="true">
          <thead>
            <tr style="background-color: #77c5ec;">
              <th style="min-width: 20px !important; max-width: 20px !important;">No.</th>
              <th>Booking Date</th>
              <th>Yoga Start Date</th>
              <th>Class Type</th>
              <th>Amount (Rs.)</th>
              <th>Days</th>
              <th>Status</th>
              <!-- <th class="numeric text-center">Action</th> -->
              <!-- <td class="numeric text-center">Action</td> -->
            </tr>
          </thead>
          <tbody>
            <tr style="background-color: #e3ebdc;"
              *ngFor="let item of BookingHistory | filter : filters | paginate: { itemsPerPage: 10, currentPage: page };  let i = index">
              <td style="min-width: 20px !important; max-width: 20px !important;">
                {{ 10 * (page - 1) + i + 1}}
              </td>
              <td>{{item.YogaBookDate | date:"dd-MMM-yyyy"}}</td>
              <td>{{item.YogaStartDate | date:"dd-MMM-yyyy"}}</td>
              <td>{{item.YogaPackageName}}</td>
              <td>{{item.Amount}}</td>
              <td>{{item.Sessions}}</td>
              <td>{{item.BookingStatus}}</td>
          </tbody>
        </table>
      </div>
      <pagination-controls (pageChange)="page = $event" [maxSize]="10" [directionLinks]="true" [autoHide]="true"
        [responsive]="true">
      </pagination-controls> <!----- Page No ------>
    </div>
  </div>
  <div class="row mt-2 d-flex justify-content-end fontsizeandfamilyCalibri">
    <button class="btn btn-success fa-sm ml-5 mt-1" (click)="LoadGuest()">Participant List</button>
  </div>
</div>

<!---Payment History-->
<div class="container ttm-bgcolor-whiteecolor" *ngIf="isPaymentHistory">

  <app-payment-history [selectedOnlinePatientRegistrationID]="SelectedOnlinePatientRegistrationID"
    [CarmePaymentGateway_key]="CarmePaymentGateway_key"
    [CarmePaymentGateway_secret]="CarmePaymentGateway_secret"></app-payment-history>

  <div class="row d-flex justify-content-center align-items-center mt-2 mb-2">
    <button type="button" class="btn btn-circle btn-secondary" title="Click to go back" (click)="GetBack()">
      Back
    </button>
  </div>
</div>

<!-- Add/Edit Guest Popup -->
<ng-template #content let-caa="close('a')">
  <div class="bg-white px-4 py-4 shadow-box rounded">
    <form name="EditClient" class="container-fluid" #f="ngForm" novalidate>
      <div class="">
        <div class="container mt-3">
          <div class="row mt-4 text-center">
            <h1 style="font-family: sans-serif;font-size: 2em;">
              {{+itemToEdit.OnlinePatientRegistrationID == 0 ? 'Add Guest details' : 'Edit Guest details '}}</h1>
          </div>
          <div class="row grid-b ">
            <div class="col-lg-3"> <!-----  Prefix ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblPrefix">Prefix </strong>
                <select class="form-select form-control" name="Prefix" id="Prefix" title="Select Prefix"
                  [(ngModel)]="itemToEdit.Prefix">
                  <option disabled value="">Select Prefix</option>
                  <option *ngFor="let prefix of Prefix" [value]="prefix.Description">{{
                    prefix.Description }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3"> <!-----  First Name ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblFirstName">First Name <span style="color: red;">*</span></strong>
                <input type="text" name="FirstName" id="FirstName" class="form-control"
                  (input)="UpperCase(itemToEdit.FirstName,'FirstName');TrimName(itemToEdit.FirstName,'FirstName');"
                  [(ngModel)]="itemToEdit.FirstName" autocomplete="off" />
              </div>
            </div>
            <div class="col-lg-3"> <!-----  Middle Name ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblMiddleName">Middle Name </strong>
                <input type="text" name="MiddleName" id="MiddleName" class="form-control"
                  (input)="UpperCase(itemToEdit.MiddleName,'MiddleName');TrimName(itemToEdit.MiddleName,'MiddleName');"
                  [(ngModel)]="itemToEdit.MiddleName" autocomplete="off" />
              </div>
            </div>
            <div class="col-lg-3"> <!-----  Last Name ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblLastName">Last Name <span style="color: red;">*</span></strong>
                <input type="text" name="LastName" id="LastName" class="form-control"
                  (input)="UpperCase(itemToEdit.LastName,'LastName');TrimName(itemToEdit.LastName,'LastName');"
                  [(ngModel)]="itemToEdit.LastName" autocomplete="off" />
              </div>
            </div>
          </div>
          <div class="row grid-b">
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri"> <!--Date Of Birth-->
                <strong id="DateOfBirth">Date Of Birth <span style="color: red;">*</span></strong>
                <div class="input-group">
                  <input class="form-control" matInput name="DateOfBirth" [matDatepicker]="DateOfBirth" [max]="Today"
                    [(ngModel)]="itemToEdit.DateOfBirth" disabled
                    (dateChange)="calculateAge(itemToEdit.DateOfBirth, Today)" />
                  <span class="input-group-append">
                    <mat-datepicker-toggle matSuffix [for]="DateOfBirth"></mat-datepicker-toggle>
                    <mat-datepicker #DateOfBirth disabled="false"></mat-datepicker>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri"> <!----- Age ------>
                <strong id="lblAge">Age </strong>
                <input type="text" name="Age" id="Age" class="form-control" [(ngModel)]="itemToEdit.Age" disabled
                  placeholder="Age">
              </div>
            </div>
            <div class="col-lg-3"> <!----- Gender ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblGender">Gender <span style="color: red;">*</span></strong>
                <select class="form-select form-control" name="Gender" id="Gender" title="Select Gender"
                  [(ngModel)]="itemToEdit.Gender">
                  <option disabled value="">Select Gender</option>
                  <option *ngFor="let gender of genders" [value]="gender.value">{{ gender.description
                    }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3"> <!----- RelationWithUser ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblRelationWithUser">Relation With User</strong>
                <input type="text" name="RelationWithUser" id="RelationWithUser" class="form-control"
                  [(ngModel)]="itemToEdit.RelationWithUser" (keypress)="validateService.alphabetOnly($event)">
              </div>
            </div>
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id='lblGSM1'> Mobile Number </strong>
                <div class="input-group">
                  <input type="text" name="RegGSM" id="RegGSM" class="form-control" [(ngModel)]="itemToEdit.GSM"
                    maxlength="10" (keypress)='validateService.numberOnly($event)' required>
                  <div class="input-group-append"> <!--Whatsapp connected-->
                    <span class="input-group-text password-toggle" (click)="GetGSMasWAGSM(isUserWAGSM, 'Guest');">
                      <i class='fa fa-whatsapp' style="color: green;" title="WhatsApp Connected?"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left">
                <strong id='lblWAGSM'>WhatsApp Mobile Number</strong>
                <!-- (click)="GetSelectedRowOpIpID(item.OpIpID,$event.target.checked);" -->
                <input type="text" name="WAGSM" id="WAGSM" class="form-control"
                  (keypress)='validateService.numberOnly($event)' maxlength="10" [(ngModel)]="itemToEdit.WAGSM"
                  required>
              </div>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri"> <!----- Preferred Language ------>
              <div class="form-group text-left">
                <strong id='lblPreferredLanguage'>Preferred Language</strong>
                <select class="form-select form-control" name="PreferredLanguage" id="PreferredLanguage"
                  title="Select Preferred Language" [(ngModel)]="itemToEdit.PreferredLanguage">
                  <option disabled value="">Select Preferred Language</option>
                  <option *ngFor="let lang of LanguageType" [value]="lang.Description">{{
                    lang.Description }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left">
                <!-- <strong id='lblUserEmail'>{{IsUserEmailSend ? 'OTP' : 'Email'}} <span style="color: red;">*</span>
                  </strong> -->
                <strong id='lblUserEmail'>Email</strong>
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="Email Address" id="email" name="email"
                    [(ngModel)]="itemToEdit.GuestEmail" (input)='validateService.validateEmail($event)' required email>
                  <!-- <div class="input-group-appent">
                      <button type="button" id="SendGuestOTP" class="btn btn-md btnpadding bg-primary ml-2"
                        [disabled]="itemToEdit.GuestEmail == ''" *ngIf="!IsEmailVerified"
                        (click)="VerifyUserEmail('GuestVerify');">
                        <i [ngClass]="isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''"></i>
                        Send OTP</button>
                      <div *ngIf="IsEmailVerified" class="text-success font-weight-bold">
                        <i class="fas fa-check-circle"></i>
                      </div>
                    </div> -->
                </div>
                <!-- <div class="input-group" *ngIf="IsUserEmailSend">
                    <input type="text" class="form-control" placeholder="OTP" id="GuestOTP" name="GuestOTP"
                      [(ngModel)]="GuestOTP" (keypress)='validateService.numberOnly($event)' required email>
                    <div class="input-group-appent">
                      <button type="button" id="VerifyGuestOTP" class="btn btn-md btnpadding bg-primary ml-2"
                        [disabled]="GuestOTP.length < 4"
                        (click)="VerifyOTP(itemToEdit.GuestEmail,GuestOTP, 'GuestVerify');">
                        Verify OTP</button>
                    </div>
                  </div> -->
              </div>
            </div>
          </div>
          <div class="row grid-b">
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left"> <!----- Address ------>
                <strong id="lblAddress">Address <span style="color: red;">*</span></strong>
                <textarea type="text" name="Address" id="Address" class="form-control" [(ngModel)]="itemToEdit.Address"
                  placeholder="Address"></textarea>
              </div>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left"> <!----- Country ------>
                <strong id="lblAddress">Country <span style="color: red;">*</span></strong>
                <input type="text" name="Country" id="Country" class="form-control" [matAutocomplete]="auto"
                  [(ngModel)]="itemToEdit.Country" placeholder="Country">
              </div>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let City of CountryandNationality | filter: itemToEdit.Country"
                  [value]="City['Country']" title="{{ City['Country'] }}">
                  {{City['Country']}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left"> <!----- State ------>
                <strong id="lblState">State</strong>
                <input type="text" name="State" id="State" class="form-control" [matAutocomplete]="autoState"
                  [(ngModel)]="itemToEdit.State" placeholder="State">
              </div>
              <mat-autocomplete #autoState="matAutocomplete">
                <mat-option *ngFor="let state of States | filter: itemToEdit.State;trackBy: trackByFn;"
                  (onSelectionChange)="GetDistrictList($event);" [value]="state['State']" title="{{ state['State'] }}">
                  {{state['State']}}
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left">
                <!----- District  [disabled]="itemToEdit.BookingID !=0" ------>
                <strong id="lblDistrict">District</strong>
                <input type="text" name="District" id="District" class="form-control" [matAutocomplete]="autoDistrict1"
                  [(ngModel)]="itemToEdit.District" placeholder="District">
              </div>
              <mat-autocomplete #autoDistrict1="matAutocomplete">
                <mat-option *ngFor="let cc of District| filter: itemToEdit.District;trackBy: trackByFn;"
                  (onSelectionChange)="GetDistrictList($event);GetCityList($event);" [value]="cc['District']"
                  title="{{ cc['District'] }}">
                  {{cc['District']}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="row grid-b">
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left"> <!----- City ------>
                <strong id="lblCity">City</strong>
                <input type="text" name="City" id="City" class="form-control" [matAutocomplete]="autoCity"
                  [(ngModel)]="itemToEdit.City" placeholder="City">
              </div>
              <mat-autocomplete #autoCity="matAutocomplete">
                <mat-option *ngFor="let aa of City | filter: itemToEdit.City;trackBy: trackByFn;" [value]="aa['City']"
                  title="{{ aa['City'] }}">
                  {{aa['City']}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri"> <!----- Nationality ------>
                <strong id="lblNationality">Nationality <span style="color: red;">*</span></strong>
                <input type="text" name="Nationality" id="Nationality" class="form-control"
                  [matAutocomplete]="autoNationality" [(ngModel)]="itemToEdit.Nationality" placeholder="Nationality">
              </div>
              <mat-autocomplete #autoNationality="matAutocomplete" (optionSelected)="SetMandatoryAadharandPassport();">
                <mat-option *ngFor="let Nation of CountryandNationality | filter: itemToEdit.Nationality"
                  [value]="Nation['Nationality']" title="{{ Nation['Nationality'] }}">
                  {{Nation['Nationality']}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3"> <!----- Aadhar No ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblAadharNo">Aadhar No.</strong>
                <input type="text" name="AadharNo" id="AadharNo" class="form-control" [(ngModel)]="itemToEdit.AadharNo"
                  (keypress)="validateService.numberOnly($event)" (input)="ValidateAadhaar(itemToEdit.AadharNo)"
                  placeholder="Aadhar No" maxlength="12">
              </div>
              <small *ngIf="!isValidAadhaar" class="text-danger fontsizeandfamilyCalibri">
                Invalid Aadhaar Number. please enter valid Aadhaar Number.
              </small>
            </div>
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri"> <!----- Passport No ------>
                <strong id="lblPassportNo">Passport No. </strong>
                <input type="text" name="PassportNo" id="PassportNo" class="form-control"
                  [(ngModel)]="itemToEdit.PassportNo" placeholder="Passport No" maxlength="20">
              </div>
            </div>
          </div>
          <div class="row grid-b">
            <div class="col-lg-3"> <!----- Pincode ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblPincode">Pincode</strong>
                <input type="text" name="Pincode" id="Pincode" class="form-control" [(ngModel)]="itemToEdit.PinCode"
                  (keypress)="validateService.numberOnly($event)" maxlength="10">
              </div>
            </div>
          </div>
          <div class="d-flex">
            <button type="button" id="btnClose" class="btn btn-md bg-primary mr-3" (click)="(caa)">
              <i class="fa fa-times mr-1" aria-hidden="true"></i>
              Close</button> <!----- Pop Up Close ------>
            <button type="button" id="SaveGuest" [disabled]="f.form.pristine" class="btn btn-md bg-primary"
              (click)="SaveGuest()">
              <i [ngClass]="isInProgress ? 'spinner-border spinner-border-sm mr-1' : 'fa fa-save mr-1'"></i>
              Save</button> <!----- Save Data ------>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>